import "core-js/modules/es.reflect.construct.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "regenerator-runtime/runtime.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.splice.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';
import { InvoerService } from '~/shared/service/invoer.service';
import { MainStore } from '~/store/index';
var InvoerModule = /*#__PURE__*/function (_VuexModule) {
  _inherits(InvoerModule, _VuexModule);
  var _super = _createSuper(InvoerModule);
  function InvoerModule() {
    var _this;
    _classCallCheck(this, InvoerModule);
    _this = _super.apply(this, arguments);
    _this.yearList = [];
    _this.productHierarchy = [];
    _this.selectedYear = 2026;
    _this.selectionList = [];
    _this.preview = null;
    return _this;
  }
  _createClass(InvoerModule, [{
    key: "getYears",
    get: function get() {
      return this.yearList;
    }
  }, {
    key: "getProducts",
    get: function get() {
      return this.productHierarchy;
    }
  }, {
    key: "SetSelectedYear",
    value: function SetSelectedYear(year) {
      this.selectedYear = year;
    }
  }, {
    key: "setYears",
    value: function setYears(years) {
      this.yearList = years;
    }
  }, {
    key: "setProducts",
    value: function setProducts(products) {
      this.selectionList = [];
      this.productHierarchy = products;
    }
  }, {
    key: "SetSelectedYearById",
    value: function SetSelectedYearById(yearId) {
      var year = this.yearList.filter(function (p) {
        return p.id === yearId;
      });
      if (year.length > 0) {
        this.selectedYear = year[0].year;
      }
    }
  }, {
    key: "UpdateSelectieAantal",
    value: function UpdateSelectieAantal(selectie) {
      var selectedItem = this.selectionList.filter(function (p) {
        return p.valueId === selectie.valueId;
      });
      if (selectedItem.length === 0) {
        this.selectionList.push(selectie);
      }
      if (selectedItem.length === 1) {
        if (selectie.aantal === null) {
          var index = this.selectionList.indexOf(selectedItem[0]);
          if (index > -1) {
            this.selectionList.splice(index, 1);
          }
        } else {
          selectedItem[0].aantal = selectie.aantal;
        }
      }
    }
  }, {
    key: "SetPreview",
    value: function SetPreview(previewData) {
      this.preview = previewData;
    }
  }, {
    key: "getAllYears",
    value: function () {
      var _getAllYears = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return InvoerService.getYearsAsync().then(function (resp) {
                _this2.setYears(resp);
              }).catch(function (error) {
                throw error;
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getAllYears() {
        return _getAllYears.apply(this, arguments);
      }
      return getAllYears;
    }()
  }, {
    key: "getProductsByYear",
    value: function () {
      var _getProductsByYear = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return InvoerService.getProductsByYear(this.selectedYear).then(function (resp) {
                _this3.setProducts(resp);
              }).catch(function (error) {
                throw error;
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getProductsByYear() {
        return _getProductsByYear.apply(this, arguments);
      }
      return getProductsByYear;
    }()
  }, {
    key: "getPreviewData",
    value: function () {
      var _getPreviewData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(request) {
        var _this4 = this;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return InvoerService.getPreviewData(request).then(function (resp) {
                _this4.SetPreview(resp);
              }).catch(function (error) {
                throw error;
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getPreviewData(_x) {
        return _getPreviewData.apply(this, arguments);
      }
      return getPreviewData;
    }()
  }, {
    key: "clearPreviewData",
    value: function clearPreviewData() {
      this.SetPreview(null);
    }
  }]);
  return InvoerModule;
}(VuexModule);
__decorate([Mutation], InvoerModule.prototype, "SetSelectedYear", null);
__decorate([Mutation], InvoerModule.prototype, "setYears", null);
__decorate([Mutation], InvoerModule.prototype, "setProducts", null);
__decorate([Mutation], InvoerModule.prototype, "SetSelectedYearById", null);
__decorate([Mutation], InvoerModule.prototype, "UpdateSelectieAantal", null);
__decorate([Mutation], InvoerModule.prototype, "SetPreview", null);
__decorate([Action], InvoerModule.prototype, "getAllYears", null);
__decorate([Action], InvoerModule.prototype, "getProductsByYear", null);
__decorate([Action], InvoerModule.prototype, "getPreviewData", null);
__decorate([Action], InvoerModule.prototype, "clearPreviewData", null);
InvoerModule = __decorate([Module({
  namespaced: true,
  name: 'InvoerModule',
  dynamic: true,
  store: MainStore
})], InvoerModule);
export default InvoerModule;